import { call, put, takeEvery } from "redux-saga/effects";

import {
  getCountriesFailure,
  getCountriesStart,
  getCountriesSuccess,
  getLeaguesFailure,
  getLeaguesStart,
  getLeaguesSuccess,
  getPopularCountriesStart,
  getPopularCountriesSuccess,
  getPopularCountriesFailure,
  // getSportBookBannersStart,
  // getSportBookBannersSuccess,
  // getSportBookBannersFailure,
  getSportsFailure,
  getSportsStart,
  getSportsSuccess,
  getTopLeaguesFailure,
  getTopLeaguesStart,
  getTopLeaguesSuccess
} from "../../redux/filters";
import SportsService from "../../services/filters";
import { showErrorMessage } from "../../../redux-saga/redux/toast";

// function* LobbyBannersWorker(action) {
//   try {
//     const { data, error } = yield SportsService.getBannersData(action.payload);
//     if(data) {
//       yield put(getSportBookBannersSuccess(data));
//     }
//     if (error) {
//       yield put(showErrorMessage({ msg: error.message }));
//       yield put(getSportBookBannersFailure());
//     }
//   } catch (error) {
//     yield put(showErrorMessage({ msg: error.message }));
//     yield put(getSportBookBannersFailure());
//   }
// }
function* filters() {
  yield takeEvery(
    [getSportsStart.type, getCountriesStart.type],
    sportBookWorker
  );
  yield takeEvery(getTopLeaguesStart.type, topLeaguesWorker);
  yield takeEvery(getLeaguesStart.type, leaguesWorker);
  yield takeEvery(getPopularCountriesStart.type, popularCountryWorker);
}

function* sportBookWorker(action) {
  try {
    switch (action.type) {
      case getSportsStart.type: {
        const { data, error } = yield SportsService.getSports(action?.payload);
        if (data) {
          yield put(
            getSportsSuccess(
              data?.map((sport) => ({
                ...sport
              })) || []
            )
          );
        }
        if (error) {
          yield put(showErrorMessage({ msg: error }));
          yield put(getSportsFailure());
        }
        break;
      }
      case getCountriesStart.type: {
        const { data, error } = yield SportsService.getCountries(
          action.payload
        );
        if (data) {
          yield put(
            getCountriesSuccess({
              data: data,
              isTop: action?.payload?.isTop
            })
          );
        }
        if (error) {
          yield put(showErrorMessage({ msg: error }));
          yield put(getCountriesFailure());
        }
        break;
      }
      default: {
        break;
      }
    }
  } catch (error) {
    console.log(error);
    switch (action.type) {
      case getSportsStart.type: {
        yield put(getSportsFailure());
        break;
      }
      case getCountriesStart.type: {
        yield put(getCountriesFailure());
        break;
      }
      default: {
        break;
      }
    }
    yield put(showErrorMessage({ msg: error }));
  }
}

function* topLeaguesWorker(action) {
  try {
    const { data, error } = yield call(SportsService.getTopLeagues, action);
    if (data) {
      yield put(getTopLeaguesSuccess(data));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error }));
      yield put(getTopLeaguesFailure());
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error }));
    yield put(getTopLeaguesFailure());
  }
}

function* leaguesWorker(action) {
  try {
    const { data, error } = yield call(SportsService.getLeagues, action);

    if (data) {
      yield put(
        getLeaguesSuccess({
          data,
          isCountry: action.payload.isCountry,
          leagueId: action.payload?.leagueId
        })
      );
    }
    if (error) {
      yield put(showErrorMessage({ msg: error }));
      yield put(getLeaguesFailure());
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error }));
    yield put(getLeaguesFailure());
  }
}

function* popularCountryWorker(action) {
  try {
    const { data, error } = yield call(SportsService.getPopularCountry, action);
    if (data) {
      yield put(getPopularCountriesSuccess(data));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error }));
      yield put(getPopularCountriesFailure());
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error }));
    yield put(getPopularCountriesFailure());
  }
}

export default filters;
